import React from "react";
import useIfLoggedIn from "../../../hooks/useIfLoggedIn";

export default function LoginPath({ children, ...props }) {
  useIfLoggedIn();
  return <div {...props}>{children}</div>;
}
